import { formatMoney } from '../../../utils/common';
import Payment from '../../../services/Payment';

export const requestMessageError = (err) => {
  if (err.response) {
    return err.response.data.message
      ? err.response.data.message
      : 'Houve um erro de comunicação. Verifique sua conexão e tente novamente mais tarde.';
  }
  return 'Houve um erro de comunicação. Verifique sua conexão e tente novamente mais tarde.';
};

export const formatFinalValue = ({
  cupomObj,
  setCupomObj,
  referCodeObj,
  valor,
}) => {
  const value_refer_code = referCodeObj ? referCodeObj.valor.toFixed(2) : 0;
  const value_cupom = cupomObj ? cupomObj.valor / 100 : 0;
  const final_value = valor - value_refer_code - value_cupom;

  return formatMoney(final_value < 0 ? 0 : final_value);
};

const paymentServiceAndSignature = async ({
  setLoading,
  token,
  id,
  numCartao,
  titular,
  validade,
  codigoCartao,
  assinatura,
  email,
  cupomObj,
  props,
  referCodeObj,
  servico,
  cpf_cnpj,
  address,
  username,
  signaturePlan,
  usuario,
  id_payment,
  portal,
}) => {
  setLoading(true);
  const number = numCartao ? numCartao.split(' ').join('') : '';

  const exists_signature = false;

  const first_name = titular ? titular.split(' ')[0] : '';
  const last_name = titular ? titular.trim().split(' ')[1] : '';
  const month = validade ? validade.split('/')[0] : '';
  const year = validade ? `20${validade.split('/')[1]}` : '';

  return await Payment.service_signature_payment({
    token,
    id,
    assinatura,
    referCodeObj,
    number,
    codigoCartao,
    first_name,
    last_name,
    month,
    year,
    email,
    cpf_cnpj,
    address,
    username,
    exists_signature,
    servico,
    cupomObj,
    setLoading,
    props,
    signaturePlan,
    id_payment,
    usuario,
    portal,
  });
};

export const handle_payment = async ({
  props,
  setLoading,
  card,
  token,
  id,
  assinatura,
  email,
  cupomObj,
  servico,
  cpf_cnpj,
  address,
  username,
  referCodeObj,
  signaturePlan,
  id_payment,
  usuario = null,
  portal,
}) => {
  setLoading(true);
  // const { type } = props.state;
  const { numCartao, titular, validade, codigoCartao } = card;

  if (!id_payment) {
    return paymentServiceAndSignature({
      setLoading,
      token,
      id,
      numCartao,
      titular,
      validade,
      codigoCartao,
      assinatura,
      email,
      cupomObj,
      props,
      referCodeObj,
      usuario,
      servico,
      cpf_cnpj,
      address,
      username,
      signaturePlan,
      portal,
    });
  }

  setLoading(false);

  return paymentServiceAndSignature({
    setLoading,
    token,
    id,
    numCartao,
    titular,
    validade,
    codigoCartao,
    assinatura,
    email,
    cupomObj,
    props,
    referCodeObj,
    usuario,
    servico,
    cpf_cnpj,
    address,
    username,
    signaturePlan,
    id_payment,
    portal,
  });
};

export const default_payment = async ({
  token,
  id,
  setLoading,
  setDefaultPayment,
  // modalizeDefaultPayment,
}) => {
  await Payment.get_payment({
    token,
    id,
    setLoading,
    setDefaultPayment,
    // modalizeDefaultPayment,
  });
};
